import { DateTime, Duration } from "luxon";
import { getDateTime } from "./getDateTime";

const now = (): string => {
  return DateTime.utc().toISO()!;
};

const fromDateTime = (args: { dateTime: DateTime }): string | null => {
  const { dateTime } = args;
  return dateTime.toUTC().toISO();
};

const fromDateAndTimeOfDay = (args: { isoDate: string; timeOfDay: string; timezone: string }): string | null => {
  return getDateTime.fromIsoDateAndTimeOfDay(args).toUTC().toISO(); // can return null if, say, timeOfDay is ASAP
};

const fromDateAndTimeOfDayAndDuration = (args: {
  durationObject: Duration;
  isoDate: string;
  timeOfDay: string;
  timezone: string;
}): string | null => {
  return getDateTime.fromIsoDateAndTimeOfDay(args).plus(args.durationObject).toUTC().toISO(); // returns null if, say, timeOfDay is ASAP
};

export const getIsoDateTimeUtc = {
  now,
  fromDateTime,
  fromDateAndTimeOfDay,
  fromDateAndTimeOfDayAndDuration,
};
